<template>
  <div class="innerBox">

    <h2 class="mb-4">Estimator</h2>
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter</h4>
      </template>
      <div class="row outerBox filterBox" style="padding:0">
        <div class="col row">
          <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Cari</label>
            <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search">
          </div>
          <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Tanggal</label>
            <flat-pickr
              v-model="selected.date"
              :config="rangeConfig"
              placeholder="Pilih Tanggal"
            ></flat-pickr>
          </div>
          <div class="col-md-4" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
            <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
          </div>
        </div>
      </div>
    </panel>

    
    <vue-universal-table
      :buttons="vue_universal_table.buttons"
      :dummy_table="false"
      :filter="filter"
      :fields="vue_universal_table.fields"
      :update="vue_universal_table.update"
      api_url="/api/v1/workorder/listing"
      :process_data='vue_universal_table.process_data'
      :disable_sort="true"
      @onEstimasiBaru="createNewWorkOrder"
      @onBukaEstimasi="viewDetailWO"
    ></vue-universal-table>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    data () {
      const start = moment().startOf('year').format('YYYY-MM-DD');
      let end  = new moment().format('YYYY-MM-DD')

      return {
        data : null,
        filter: {
          start: start,
          end: end,
          search : ''
        },
        mobile : this.isMobile(),
        selected : {
          date : `${start} to ${end}`,
        },
        rangeConfig: {
          mode: 'range',
          altInput: true,
          altInputClass: 'form-control input flatpickr-input w-100',
          animate: !this.isRTL()
        },
        showNewUserModal : false,
        apiLoading: true,
        vue_universal_table : {
          update: 0,
          special_buttons : ['estimasiBaru'],
          buttons : [
            {
              title : 'bukaEstimasi',
              variable : 'form_code',
              class : 'btn-outline-primary fas fa-box-open'
            }
          ],
          process_data : `
            for (var i in data) { 
              data[i].log_name = data[i].log ? data[i].log.name : '-'
              data[i].step_name = data[i].step ? data[i].step.name : '-'
            }`,
          fields : [
            {
              title : 'Work Order ID',
              variable : 'form_code'
            },
            {
              title : 'Nama Pelanggan',
              variable : 'customer_name'
            },
            {
              title : 'Status Mobil',
              variable : 'log_name'
            },
            {
              title : 'Step Pekerjaan Terakhir',
              variable : 'step_name'
            },
            {
              title : 'Dibuat Pada',
              variable : 'created_at'
            },
            {
              title : 'No Polisi',
              variable : 'registration'
            },
            {
              title : 'CSO',
              variable : 'CSO'
            }
          ]
        }
      }
    },
    components : {

    },
    mounted () {
    },
    methods : {
      createNewWorkOrder () {
        this.$router.push({name : 'WorkOrderFormNew'})
      },
      viewDetailWO (x) {
        this.$router.push({name : 'EstimatorApplication', params: {id : x.replace(/"/g, "")}})
      }
    },
    watch : {
      'selected.date'(){
        var date = this.selected.date.split(" to ");
        this.filter.start = date[0]
        this.filter.end = date[1] ? date[1] : date[0]
      }
    }
  }
</script>

<style scoped>
  
</style>